<template>
  <div class="footer">
      <div class="wrap">
          <div class="left">
              <ul class="link">
                  <li v-for="(item,index) in link" :key="index">
                      <router-link :to="item.path">{{item.name}}</router-link>
                  </li>
              </ul>
              <p class="friend">友情链接 : <a href="http://www.loto-health.com">Loto-health</a><a href="http://www.loto-health.de">德国石荷州抗衰老机构</a></p>

              <a href="https://beian.miit.gov.cn/" target="_blank"><div class="baian"><img src="./../assets/img/beianIcon.png" alt="备案"> Copyright © 2010-2019 浙江鹿图健康科技有限公司 浙ICP备19009420号-2</div></a>
              <!-- <a href="http://www.beian.miit.gov.cn" target="_blank"></a> -->
          </div>
          <div class="right">
              <img src="./../assets/img/code.png" alt="微信二维码">
              <p>关注微信公众号</p>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
        link: [
            {
                name: '商务合作',
                path: '/',
            },
            {
                name: '用户服务',
                path: '/',
            },
            {
                name: '平台合作',
                path: '/',
            },
            {
                name: '联系我们',
                path: '/contact',
            },
            {
                name: '意见反馈',
                path: '/',
            },
            {
                name: 'loto-hof协议',
                path: '/',
            },
        ]
    }
  },

  components: {},
}

</script>

<style scoped lang="less">
@import "./../assets/css/footer.less";
</style>


// WEBPACK FOOTER //
// src/components/footer.vue